import { HTTP } from '@/http/http-client';
import { mapParams } from '@/utils/mapParams';

const getShoppingCart = ({ parentId, options }) =>
    HTTP.get(`parents/${parentId}/schools/slug/cart?${mapParams(options)}`).then(({ data }) => data);

const removeActivityRosterFromCart = ({ parentId, options }) =>
    HTTP.delete(`parents/${parentId}/schools/slug/cart/roster?${mapParams(options)}`).then(({ data }) => data);

const removeDateFromRosterInCart = ({ parentId, options }) =>
    HTTP.delete(`parents/${parentId}/schools/slug/cart/drop-in?${mapParams(options)}`).then(({ data }) => data);

const removeRosterAftercareDayFromCart = ({ parentId, rosterId, aftercareDayId, activityType }) =>
    HTTP.delete(`parents/${parentId}/schools/slug/cart/roster/${rosterId}?activityType=${activityType}&aftercareDayId=${aftercareDayId}`).then(({ data }) => data);

const removeAddonFromActivityRosterInCart = ({ parentId, options }) =>
    HTTP.delete(`parents/${parentId}/schools/slug/cart/addon?${mapParams(options)}`).then(({ data }) => data);

const createStripeTokenForCard = async ({ cardNumber, cardExpiry, cardCvc, stripe }) => {
    try {
        const response = await stripe.createToken(cardNumber, cardExpiry, cardCvc);
        return response;
    } catch (error) {
        throw error;
    }

};

const getExistCardInfo = (parentId) =>
    HTTP.get(`parents/${parentId}/schools/slug/billing`).then(({ data }) => data);

const createBillingInfo = ({ parentId, options }) =>
    HTTP.post(`parents/${parentId}/schools/slug/billing?${mapParams(options)}`).then(({ data }) => data);

const paymentInfo = ({ options, couponCode }) =>
    HTTP.post(`schools/slug/activities/payment?${mapParams(options)}`, couponCode);

export default {
    getShoppingCart,
    removeActivityRosterFromCart,
    removeRosterAftercareDayFromCart,
    removeDateFromRosterInCart,
    removeAddonFromActivityRosterInCart,
    createStripeTokenForCard,
    getExistCardInfo,
    createBillingInfo,
    paymentInfo
};


// WEBPACK FOOTER //
// ./src/http/services/shoppingCartService.js